import { ErrorBoundary } from '@sentry/react';
import { Suspense } from 'react';

import { EngagementSection } from './engagement-section';
import { PerformanceOverview } from './performance-overview';
import { TrendsSection } from './trends-section';

import { ErrorFallback } from '@/shared/components/error-fallback';
import { PageLoadingFallback } from '@/shared/components/page-loading-fallback';
import { useCurrentPageRoutingStatus } from '@/shared/hooks/use-is-routing';
import { useRestoreScroll } from '../../insight-layout/hook/use-insight-scroll-container';

export function PerformancePage() {
  const fetchEnabled = useCurrentPageRoutingStatus({ currentPath: '/insight/performance' });
  useRestoreScroll();
  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback
          error={error as Error}
          reset={resetError}
          title="Failed to load performance data"
          description="We encountered an error while loading your performance dashboard. Please try again or contact support if the problem persists."
        />
      )}
    >
      <Suspense fallback={<PageLoadingFallback />}>
        <PerformanceOverview fetchEnabled={fetchEnabled} />
        <TrendsSection fetchEnabled={fetchEnabled} />
        <EngagementSection fetchEnabled={fetchEnabled} />
      </Suspense>
    </ErrorBoundary>
  );
}
